module.exports = __webpack_public_path__ + "img/oneWingOwl.45eaedee.svg";